import React from "react";

const QUIZ_STATE_KEY = "chatbot:quizState";

/**
 * QuizPanel — Panel nhỏ hiển thị trạng thái quiz (số câu, điểm).
 */
function QuizPanel({ quizState, onEndQuiz }) {
    if (!quizState || !quizState.active) return null;

    const { correct = 0, total = 0, topic = "" } = quizState;
    const accuracy = total > 0 ? Math.round((correct / total) * 100) : 0;

    return (
        <div className="flex items-center gap-3 px-3 py-2 bg-gradient-to-r from-purple-50 to-indigo-50 border border-purple-200 rounded-xl text-xs">
            <div className="flex items-center gap-1.5">
                <span className="text-sm">❓</span>
                <span className="font-semibold text-purple-800">Quiz</span>
                {topic && <span className="text-purple-600">· {topic}</span>}
            </div>

            <div className="flex items-center gap-3 ml-auto">
                <div className="flex items-center gap-1">
                    <span className="text-green-600 font-bold">{correct}</span>
                    <span className="text-gray-400">/</span>
                    <span className="text-gray-700 font-medium">{total}</span>
                    <span className="text-gray-500">câu</span>
                </div>

                {total > 0 && (
                    <div className={`font-bold ${accuracy >= 70 ? "text-green-600" : accuracy >= 40 ? "text-yellow-600" : "text-red-600"}`}>
                        {accuracy}%
                    </div>
                )}

                <button
                    type="button"
                    onClick={onEndQuiz}
                    className="px-2 py-1 text-[10px] font-medium text-purple-700 bg-purple-100 hover:bg-purple-200 rounded-md transition-colors"
                >
                    Kết thúc
                </button>
            </div>
        </div>
    );
}

export { QUIZ_STATE_KEY };
export default QuizPanel;
